import { render, staticRenderFns } from "./p-order-submit.vue?vue&type=template&id=79a0cdcc"
import script from "./p-order-submit.vue?vue&type=script&lang=js"
export * from "./p-order-submit.vue?vue&type=script&lang=js"
import style0 from "./p-order-submit.vue?vue&type=style&index=0&id=79a0cdcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports